import styles from './main.scss'
import Skeleton from "react-loading-skeleton";

const LoadingScreen = () => {
    return (
            <Skeleton
                containerClassName={"loading"}
                style={{width:"100%", height:"100%"}}
            />
        )

}

export default LoadingScreen